<nav class="navbar navbar-expand-lg navbar-dark bg-primary mb-0">
    <div class="container-fluid">
        <img src="assets/images/back_office_logo.png" [height]="40" alt="Calmean Family Logo" class="logo">
        <a class="navbar-brand" routerLink="/dashboard">Calmean Family Backoffice {{isStaging? 'STAGE' : ''}}</a>
        <div class="collapse navbar-collapse" id="navbarNav">
            <div class="d-flex ms-auto">
                <div class="d-flex flex-column my-auto me-3 text-end">
                    <small class="text-white">{{environment.version}}</small>
                    <small class="text-white">{{environment.time}}</small>
                </div>
                <button class="btn btn-outline-light" (click)="logout()">Wyloguj</button>
            </div>
        </div>
    </div>
</nav>

<!-- Left sidebar: always visible -->
<aside class="sidebar">
    <ul class="nav flex-column">
        <li class="nav-item">
            <a class="nav-link" routerLink="/devices" routerLinkActive="active">
                <i class="fa fa-search me-2"></i>
                Urządzenia
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" routerLink="/accounts/search" routerLinkActive="active">
                <i class="fa fa-remove me-2"></i>
                Usuwanie konta
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" routerLink="/tools/upload-csv" routerLinkActive="active">
                <i class="fa fa-sim-card me-2"></i>
                Konfiguracja SIM
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" routerLink="/promo-codes" routerLinkActive="active">
                <i class="fa fa-code me-2"></i>
                Promo codes
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" routerLink="/device-config/standard" routerLinkActive="active">
                <i class="fa fa-cogs me-2"></i>
                Konfiguracja urządzeń
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" routerLink="/change-sim" routerLinkActive="active">
                <i class="fa fa-sim-card me-2"></i>
                Wymiana karty SIM
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" routerLink="/generation-boxes" routerLinkActive="active">
                <i class="fa fa-paper-plane me-2"></i>
                Wysyłka kart SIM
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" routerLink="/migrationOfCardNumbers" routerLinkActive="active">
                <i class="fa fa-cogs me-2"></i>
                Migracja numerów kart
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" (click)="smsGW()">
                <i class="fa fa-sms me-2"></i>
                SMS GW
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" routerLink="/searchSim" routerLinkActive="active">
                <i class="fa fa-search me-2"></i>
                Karty SIM
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" routerLink="/sendPackage" routerLinkActive="active">
                <i class="fa fa-cubes me-2"></i>
                Pakowanie
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" routerLink="/panel" routerLinkActive="active">
                <i class="fa fa-edit me-2"></i>
                Lista urządzeń
            </a>
        </li>
        <li class="nav-item" *ngIf="hasRight('BACKOFFICE_PGW')">
            <a class="nav-link" routerLink="/configurePayments" routerLinkActive="active">
                <i class="fa fa-money-bill me-2"></i>
                Konfiguracja płatności
            </a>
        </li>
    </ul>
</aside>
